// export const onlyNumbers = (value) => {
//   return value.replace(/[^0-9]/g, ""); // тільки цифри
// };
export const onlyNumbers = (value) => {
  if (!value) return "";

  // 1) прибираємо все, крім цифр і крапки
  let v = value.replace(/[^0-9.]/g, "");

  // 2) не дозволяємо крапку на початку
  if (v.startsWith(".")) {
    v = v.slice(1);
  }

  // 3) залишаємо тільки першу крапку
  const firstDot = v.indexOf(".");

  if (firstDot !== -1) {
    v = v.slice(0, firstDot + 1) + v.slice(firstDot + 1).replace(/\./g, "");
  }

  return v;
};
